import React from 'react';
import { Flex, Col, Row, Typography, Rate } from 'antd';
import { IconContext } from 'react-icons';
import { FaRegCheckCircle } from 'react-icons/fa';

const Skills = ({ Data, i18, type, mode = "icon" }) => {
  const skills = Data.skills;
  const skillIconSize = '1.6rem';

  return (
    <React.Fragment>
      <div className="section" id="projects">
        <Row>
          <Col span={24}>
            {type == 'soft' && (
              <Typography.Title level={4} style={{ textAlign: 'center' }}>
                {i18.TIT_SOFT_SKILLS}
              </Typography.Title>
            )}
            {type != 'soft' && (
              <Typography.Title level={4} style={{ textAlign: 'center' }}>
                {i18.TIT_PROF_SKILLS}
              </Typography.Title>
            )}
          </Col>
          <Col span={24}>
            <Typography.Text
              italic="true"
              style={{
                display: 'block',
                textAlign: 'center',
                marginBottom: '1rem',
              }}
            >
              {'--o--'}
              <hr />
            </Typography.Text>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Row gutter={[16, 18]}>
              {skills
                .filter((i) => i.type === type)
                .map((item, index) => (
                  <Col xs={8} md={8} lg={8} key={index}>
                    <Flex align="flex-start" gap={12}>
                      {/* Avatar / Icon */}
                      <IconContext.Provider
                        value={{ size: skillIconSize, color: '#808080' }}
                      >
                        {item.icon}
                      </IconContext.Provider>

                      {/* Content */}
                      <Flex vertical gap={4}>
                        <Typography.Text strong>{item.title}</Typography.Text>
                        {mode == "percentage" &&
                          <Typography.Text>{item.skillQualification * 10}%</Typography.Text>
                        }
                        {mode == "icon" &&
                          <Rate
                            count={10}
                            defaultValue={item.skillQualification}
                            character={<FaRegCheckCircle />}
                            disabled={true}
                            style={{ color: '#808080', fontSize: '14px' }}
                          />
                        }
                      </Flex>
                    </Flex>
                  </Col>
                ))}
            </Row>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default Skills;
